/* Release context only. Reuses Shopify Customer Events and the installed Clarity
 * app; never installs another tag, grants consent, or reads visitor identity.
 */
(function () {
  'use strict';
  if (window.RPExperience) return;
  var script = document.currentScript;
  var context = Object.freeze({
    site_version: 'v2',
    site_environment: script && script.getAttribute('data-site-environment') || 'preview',
    page_type: script && script.getAttribute('data-page-type') || 'other'
  });
  var published = false;
  var publishing = false;
  var loaded = document.readyState === 'complete';
  var clarityTagged = false;
  var privacyLoading = false;
  var privacyFailed = false;
  var timer = null;
  var attempts = 0;

  function allowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !!(privacy && privacy.analyticsProcessingAllowed());
    } catch (error) { return false; }
  }

  function enrich(data) { return Object.assign({}, data || {}, context); }
  window.RPExperience = Object.freeze({ context: context, enrich: enrich, allowed: allowed });

  function loadPrivacy() {
    if (privacyLoading || privacyFailed || (window.Shopify && window.Shopify.customerPrivacy)) return;
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
    privacyLoading = true;
    try {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], function (error) {
        privacyLoading = false;
        privacyFailed = !!error;
        if (!error) sync();
      });
    } catch (error) { privacyLoading = false; privacyFailed = true; }
  }

  function schedule() {
    if (timer !== null || attempts >= 30 || privacyFailed) return;
    timer = window.setTimeout(function () {
      timer = null;
      attempts += 1;
      sync();
    }, 1000);
  }

  function sync() {
    loadPrivacy();
    if (!allowed()) {
      if (!(window.Shopify && window.Shopify.customerPrivacy)) schedule();
      return;
    }
    // Customer Events pixels initialize asynchronously. Wait until page load so
    // the connected pixel has subscribed before sending this one-off marker.
    if (loaded && !published && !publishing) {
      try {
        var analytics = window.Shopify && window.Shopify.analytics;
        if (analytics && typeof analytics.publish === 'function') {
          var result = analytics.publish('repubblica:experience_viewed', enrich());
          if (result && typeof result.then === 'function') {
            publishing = true;
            result.then(function (accepted) {
              publishing = false;
              published = accepted !== false;
              if (!published) schedule();
            }, function () { publishing = false; schedule(); });
          } else { published = result !== false; }
        }
      } catch (error) { /* A blocked analytics service must not affect shopping. */ }
    }
    if (!clarityTagged && typeof window.clarity === 'function') {
      try {
        window.clarity('set', 'site_version', context.site_version);
        window.clarity('set', 'site_environment', context.site_environment);
        window.clarity('set', 'page_type', context.page_type);
        window.clarity('event', 'experience_view');
        clarityTagged = true;
      } catch (error) { /* Retry only while the consent check still allows it. */ }
    }
    if (!published || !clarityTagged) schedule();
  }

  document.addEventListener('visitorConsentCollected', function () {
    attempts = 0;
    sync();
  });
  if (!loaded) window.addEventListener('load', function () { loaded = true; sync(); }, { once: true });
  sync();
})();
